module.exports = __webpack_public_path__ + "static/media/public.397af1f6.png";